// hoover element with data-custom-tooltip and show tooltip
$(document).on('mouseenter', '[data-custom-tooltip]', function () {
    // let tooltip = $(this).attr('data-custom-tooltip');

    // get tooltip text = data-custom-tooltip-text
    let tooltipText = $(this).attr('data-custom-tooltip-text');

    // if tooltip text is empty, do not show tooltip
    if (tooltipText === '') {
        return;
    }

    // interpret tooltip text as html
    tooltipText = tooltipText.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

    // make text black
    tooltipText = '<span class="text-dark">' + tooltipText + '</span>';

    // show custom tooltip above element, white background and set pointer events to none
    $(this).tooltip('dispose');
    $(this).tooltip({
        title: tooltipText,
        placement: 'bottom',
        html: true,
        template: '<div class="tooltip custom-tooltip-block " role="tooltip"><div class="tooltip-inner bg-white border border-primary"></div></div>',
        trigger: 'manual',
    }).tooltip('show');
});

// hide tooltip when leaving the trigger element
$(document).on('mouseleave blur click', '[data-custom-tooltip]', function () {
    $(this).tooltip('hide');
    $(this).tooltip('dispose');
});

// when .go-to-prev-state is clicked, change state of sales order
$(document).on('click', '.go-to-prev-state', function () {
    let salesOrderId = $(this).attr('data-sales-order-id');
    let state = $(this).attr('data-state');
    document.location = '/admin/sales-orders/' + salesOrderId + '/change-state/' + state;
});
// when .go-to-next-state is clicked, change state of sales order
$(document).on('click', '.go-to-next-state', function () {
    let salesOrderId = $(this).attr('data-sales-order-id');
    let state = $(this).attr('data-state');
    document.location = '/admin/sales-orders/' + salesOrderId + '/change-state/' + state;
});
